import React, {FC, forwardRef, Ref} from "react"

import id from "@irati/utils/id"

import {AccordionHeader} from "./"
import {AccordionContent, AccordionExpander, FlushTopHr, SpacedCard} from "./styled/AccordionItem"

interface Props {
  id?: string,
  isInner?: boolean,
  ref: Ref<any>,
  title: string
}

const AccordionItem: FC<Props> = forwardRef(({title, isInner, children, ...props}, ref) => {
  const idNamespace = id("AccordionItem", props)

  return (
    <SpacedCard id={idNamespace} isInner={isInner} flush>
      <AccordionExpander fullWidth ref={ref} id={id("expander", idNamespace)} showText={title} isInner={isInner} Header={AccordionHeader}>
        <AccordionContent id={id("content", idNamespace)} isInner={isInner}>
          {!isInner && <FlushTopHr />}
          {children}
        </AccordionContent>
      </AccordionExpander>
    </SpacedCard>
  )
})

AccordionItem.defaultProps = {
  isInner: false
}

export default AccordionItem
